/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export * from "./api/audio-api";
export * from "./api/avatar-api";
export * from "./api/banner-api";
export * from "./api/email-verify-api";
export * from "./api/invite-api";
export * from "./api/lift-api";
export * from "./api/merge-api";
export * from "./api/password-reset-api";
export * from "./api/project-api";
export * from "./api/semantic-domain-api";
export * from "./api/speaker-api";
export * from "./api/statistics-api";
export * from "./api/user-api";
export * from "./api/user-edit-api";
export * from "./api/user-role-api";
export * from "./api/word-api";
